var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"sticky-header"},[_c('header-top-vue'),_c('header-bottom-vue',{attrs:{"heading":_vm.currentYear,"specific-link":'APPOINTMENT'}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }